import { render } from "./YuebaoHelp.vue?vue&type=template&id=5b81f616&scoped=true"
import script from "./YuebaoHelp.vue?vue&type=script&lang=js"
export * from "./YuebaoHelp.vue?vue&type=script&lang=js"

import "./YuebaoHelp.vue?vue&type=style&index=0&id=5b81f616&scoped=true&lang=stylus"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b81f616"]])

export default __exports__